import { render, staticRenderFns } from "./LogContents.vue?vue&type=template&id=173d6977&"
import script from "./LogContents.vue?vue&type=script&lang=js&"
export * from "./LogContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173d6977')) {
      api.createRecord('173d6977', component.options)
    } else {
      api.reload('173d6977', component.options)
    }
    module.hot.accept("./LogContents.vue?vue&type=template&id=173d6977&", function () {
      api.rerender('173d6977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/LogContents.vue"
export default component.exports